<p-dialog header="QEC Datasets" [style]="{width: '95vw'}" [(visible)]="visible" (onHide)="closeDialog()" >
  <app-tables-main></app-tables-main>
</p-dialog>
